import { render, staticRenderFns } from "./OnboardingApproved.vue?vue&type=template&id=405ff41e&scoped=true"
import script from "./OnboardingApproved.vue?vue&type=script&lang=js"
export * from "./OnboardingApproved.vue?vue&type=script&lang=js"
import style0 from "./OnboardingApproved.vue?vue&type=style&index=0&id=405ff41e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "405ff41e",
  null
  
)

export default component.exports